var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"scangiftmodule",style:(_vm.styleForBg)},[_c('div',{staticClass:"scangiftmodule-legend"},[(_vm.titlePrefix)?_c('span',[_vm._v(_vm._s(_vm.titlePrefix))]):_vm._e(),_c('TextFormatter',{attrs:{"text":_vm.title}}),_vm._v("  ")],1),_c('div',{staticClass:"scangiftmodule-main"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }